import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router';
import Indicator from '../indicator';
import Inputcheckbox from './Inputcheckbox';

class Levels extends Component {
  constructor(props){
    super(props);
    this.state = {
      loader: true,
    };
    this.count=this.count.bind(this);
  }

  count(name,event){
    var user = this.props.match.params.user;
    var doctor = firebaseRef.auth().currentUser.uid;
    console.log(event.target.title);
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/levels/'+name.title);
    if (event.target.title === 'clear') {
      refMain.remove();
    }else{
    refMain.update({
      color: event.target.title
    });
  }
  }

componentDidMount(){
  this.setState({ loader: false });
}

  render(){
    return(
      this.state.loader ? (
        <Indicator />
      ) : (
      <div id="levels">
        <form>
          <div className="levels-inner-divs">
            <div className="levels-title"><p></p></div>
            <div className="levels-title"><p>M-L</p></div>
            <div className="levels-title"><p>PASV</p></div>
            <div className="levels-title"><p>M-R</p></div>
            <div className="levels-title"><p>BRTH</p></div>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C1</p></div>
            <Inputcheckbox title="C1-ML" group="C1" levels={this.count}/>
            <Inputcheckbox title="C1-PASV" group="C1" levels={this.count}/>
            <Inputcheckbox title="C1-MR" group="C1" levels={this.count}/>
            <Inputcheckbox title="C1-BRTH" group="C1" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C2</p></div>
            <Inputcheckbox title="C2-ML" group="C2" levels={this.count}/>
            <Inputcheckbox title="C2-PASV" group="C2" levels={this.count}/>
            <Inputcheckbox title="C2-MR" group="C2" levels={this.count}/>
            <Inputcheckbox title="C2-BRTH" group="C2" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C3</p></div>
            <Inputcheckbox title="C3-ML" group="C3" levels={this.count}/>
            <Inputcheckbox title="C3-PASV" group="C3" levels={this.count}/>
            <Inputcheckbox title="C3-MR" group="C3" levels={this.count}/>
            <Inputcheckbox title="C3-BRTH" group="C3" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C4</p></div>
            <Inputcheckbox title="C4-ML" group="C4" levels={this.count}/>
            <Inputcheckbox title="C4-PASV" group="C4" levels={this.count}/>
            <Inputcheckbox title="C4-MR" group="C4" levels={this.count}/>
            <Inputcheckbox title="C4-BRTH" group="C4" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C5</p></div>
            <Inputcheckbox title="C5-ML" group="C5" levels={this.count}/>
            <Inputcheckbox title="C5-PASV" group="C5" levels={this.count}/>
            <Inputcheckbox title="C5-MR" group="C5" levels={this.count}/>
            <Inputcheckbox title="C5-BRTH" group="C5" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C6</p></div>
            <Inputcheckbox title="C6-ML" group="C6" levels={this.count}/>
            <Inputcheckbox title="C6-PASV" group="C6" levels={this.count}/>
            <Inputcheckbox title="C6-MR" group="C6" levels={this.count}/>
            <Inputcheckbox title="C6-BRTH" group="C6" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>C7</p></div>
            <Inputcheckbox title="C7-ML" group="C7" levels={this.count}/>
            <Inputcheckbox title="C7-PASV" group="C7" levels={this.count}/>
            <Inputcheckbox title="C7-MR" group="C7" levels={this.count}/>
            <Inputcheckbox title="C7-BRTH" group="C7" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T1</p></div>
            <Inputcheckbox title="T1-ML" group="T1" levels={this.count}/>
            <Inputcheckbox title="T1-PASV" group="T1" levels={this.count}/>
            <Inputcheckbox title="T1-MR" group="T1" levels={this.count}/>
            <Inputcheckbox title="T1-BRTH" group="T1" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T2</p></div>
            <Inputcheckbox title="T2-ML" group="T2" levels={this.count}/>
            <Inputcheckbox title="T2-PASV" group="T2" levels={this.count}/>
            <Inputcheckbox title="T2-MR" group="T2" levels={this.count}/>
            <Inputcheckbox title="T2-BRTH" group="T2" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T3</p></div>
            <Inputcheckbox title="T3-ML" group="T3" levels={this.count}/>
            <Inputcheckbox title="T3-PASV" group="T3" levels={this.count}/>
            <Inputcheckbox title="T3-MR" group="T3" levels={this.count}/>
            <Inputcheckbox title="T3-BRTH" group="T3" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T4</p></div>
            <Inputcheckbox title="T4-ML" group="T4" levels={this.count}/>
            <Inputcheckbox title="T4-PASV" group="T4" levels={this.count}/>
            <Inputcheckbox title="T4-MR" group="T4" levels={this.count}/>
            <Inputcheckbox title="T4-BRTH" group="T4" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T5</p></div>
            <Inputcheckbox title="T5-ML" group="T5" levels={this.count}/>
            <Inputcheckbox title="T5-PASV" group="T5" levels={this.count}/>
            <Inputcheckbox title="T5-MR" group="T5" levels={this.count}/>
            <Inputcheckbox title="T5-BRTH" group="T5" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T6</p></div>
            <Inputcheckbox title="T6-ML" group="T6" levels={this.count}/>
            <Inputcheckbox title="T6-PASV" group="T6" levels={this.count}/>
            <Inputcheckbox title="T6-MR" group="T6" levels={this.count}/>
            <Inputcheckbox title="T6-BRTH" group="T6" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T7</p></div>
            <Inputcheckbox title="T7-ML" group="T7" levels={this.count}/>
            <Inputcheckbox title="T7-PASV" group="T7" levels={this.count}/>
            <Inputcheckbox title="T7-MR" group="T7" levels={this.count}/>
            <Inputcheckbox title="T7-BRTH" group="T7" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T8</p></div>
            <Inputcheckbox title="T8-ML" group="T8" levels={this.count}/>
            <Inputcheckbox title="T8-PASV" group="T8" levels={this.count}/>
            <Inputcheckbox title="T8-MR" group="T8" levels={this.count}/>
            <Inputcheckbox title="T8-BRTH" group="T8" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T9</p></div>
            <Inputcheckbox title="T9-ML" group="T9" levels={this.count}/>
            <Inputcheckbox title="T9-PASV" group="T9" levels={this.count}/>
            <Inputcheckbox title="T9-MR" group="T9" levels={this.count}/>
            <Inputcheckbox title="T9-BRTH" group="T9" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T10</p></div>
            <Inputcheckbox title="T10-ML" group="T10" levels={this.count}/>
            <Inputcheckbox title="T10-PASV" group="T10" levels={this.count}/>
            <Inputcheckbox title="T10-MR" group="T10" levels={this.count}/>
            <Inputcheckbox title="T10-BRTH" group="T10" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T11</p></div>
            <Inputcheckbox title="T11-ML" group="T11" levels={this.count}/>
            <Inputcheckbox title="T11-PASV" group="T11" levels={this.count}/>
            <Inputcheckbox title="T11-MR" group="T11" levels={this.count}/>
            <Inputcheckbox title="T11-BRTH" group="T11" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>T12</p></div>
            <Inputcheckbox title="T12-ML" group="T12" levels={this.count}/>
            <Inputcheckbox title="T12-PASV" group="T12" levels={this.count}/>
            <Inputcheckbox title="T12-MR" group="T12" levels={this.count}/>
            <Inputcheckbox title="T12-BRTH" group="T12" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>L1</p></div>
            <Inputcheckbox title="L1-ML" group="L1" levels={this.count}/>
            <Inputcheckbox title="L1-PASV" group="L1" levels={this.count}/>
            <Inputcheckbox title="L1-MR" group="L1" levels={this.count}/>
            <Inputcheckbox title="L1-BRTH" group="L1" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>L2</p></div>
            <Inputcheckbox title="L2-ML" group="L2" levels={this.count}/>
            <Inputcheckbox title="L2-PASV" group="L2" levels={this.count}/>
            <Inputcheckbox title="L2-MR" group="L2" levels={this.count}/>
            <Inputcheckbox title="L2-BRTH" group="L2" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>L3</p></div>
            <Inputcheckbox title="L3-ML" group="L3" levels={this.count}/>
            <Inputcheckbox title="L3-PASV" group="L3" levels={this.count}/>
            <Inputcheckbox title="L3-MR" group="L3" levels={this.count}/>
            <Inputcheckbox title="L3-BRTH" group="L3" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>L4</p></div>
            <Inputcheckbox title="L4-ML" group="L4" levels={this.count}/>
            <Inputcheckbox title="L4-PASV" group="L4" levels={this.count}/>
            <Inputcheckbox title="L4-MR" group="L4" levels={this.count}/>
            <Inputcheckbox title="L4-BRTH" group="L4" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>L5</p></div>
            <Inputcheckbox title="L5-ML" group="L5" levels={this.count}/>
            <Inputcheckbox title="L5-PASV" group="L5" levels={this.count}/>
            <Inputcheckbox title="L5-MR" group="L5" levels={this.count}/>
            <Inputcheckbox title="L5-BRTH" group="L5" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>S1</p></div>
            <Inputcheckbox title="S1-ML" group="S1" levels={this.count}/>
            <Inputcheckbox title="S1-PASV" group="S1" levels={this.count}/>
            <Inputcheckbox title="S1-MR" group="S1" levels={this.count}/>
            <Inputcheckbox title="S1-BRTH" group="S1" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>S2</p></div>
            <Inputcheckbox title="S2-ML" group="S2" levels={this.count}/>
            <Inputcheckbox title="S2-PASV" group="S2" levels={this.count}/>
            <Inputcheckbox title="S2-MR" group="S2" levels={this.count}/>
            <Inputcheckbox title="S2-BRTH" group="S2" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>S3</p></div>
            <Inputcheckbox title="S3-ML" group="S3" levels={this.count}/>
            <Inputcheckbox title="S3-PASV" group="S3" levels={this.count}/>
            <Inputcheckbox title="S3-MR" group="S3" levels={this.count}/>
            <Inputcheckbox title="S3-BRTH" group="S3" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>S4</p></div>
            <Inputcheckbox title="S4-ML" group="S4" levels={this.count}/>
            <Inputcheckbox title="S4-PASV" group="S4" levels={this.count}/>
            <Inputcheckbox title="S4-MR" group="S4" levels={this.count}/>
            <Inputcheckbox title="S4-BRTH" group="S4" levels={this.count}/>
          </div>
          <div className="levels-inner-divs">
          <div className="levels-title"><p>S5</p></div>
            <Inputcheckbox title="S5-ML" group="S5" levels={this.count}/>
            <Inputcheckbox title="S5-PASV" group="S5" levels={this.count}/>
            <Inputcheckbox title="S5-MR" group="S5" levels={this.count}/>
            <Inputcheckbox title="S5-BRTH" group="S5" levels={this.count}/>
          </div>
        </form>
      </div>
    )
    );
  }
}
export default withRouter(Levels);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Levels.js